import {createIcon} from '@chakra-ui/react'

export const PdfIcon = createIcon({
  displayName: 'PdfIcon',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M15 1.5H6C5.175 1.5 4.5 2.175 4.5 3V12C4.5 12.825 5.175 13.5 6 13.5H15C15.825 13.5 16.5 12.825 16.5 12V3C16.5 2.175 15.825 1.5 15 1.5ZM15 12H6V3H15V12ZM3 4.5H1.5V15C1.5 15.825 2.175 16.5 3 16.5H13.5V15H3V4.5ZM12 9V6.75C12 6.3375 11.6625 6 11.25 6H9.75V9.75H11.25C11.6625 9.75 12 9.4125 12 9ZM10.5 6.75H11.25V9H10.5V6.75ZM13.5 8.25H14.25V7.5H13.5V6.75H14.25V6H12.75V9.75H13.5V8.25ZM7.5 8.25H8.25C8.6625 8.25 9 7.9125 9 7.5V6.75C9 6.3375 8.6625 6 8.25 6H6.75V9.75H7.5V8.25ZM7.5 6.75H8.25V7.5H7.5V6.75Z"
      fill="currentColor"
    />
  ),
})
